import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";

export class LocalSetting extends EntityBase {
  public LocalSettingKindId;
  public LocalSettingKindTitle: string;
  public LocalSettingKindCode?: number;
  public ComputerName: string;
  public UserName: string;
  public Password: string;
  public IsWebService: boolean;
  // public PaymentTerminalProviderId?:number ;
  // public PaymentTerminalProviderTitle:string ;
  public Ip: string;
  public Port: string;
  // public PosTimeOut:number ;
  // public IBANCode:string ;
  // public IsMultiMerchantPos:boolean ;
  public IsActive: boolean;
  public ReceiveOnlineInvoice: boolean;
  public ShowOnlineInvoice: boolean;
  public PaymentMethodId: number;
  // public HasLocal: boolean;
  // public LocalServiceIp: string;
  // public PrintTemplateTypeId: string;
  // public LocalServiceIpAddress:number;
}

export enum LocalSettingKind {
  /// <summary>
  /// چاپگر
  /// </summary>
  Printer = 1,
  /// <summary>
  /// کارتخوان
  /// </summary>
  Pos = 2,
  /// <summary>
  /// دلینو
  /// </summary>
  Delino = 3,
  /// <summary>
  /// تیلت پوز
  /// </summary>
  TabletPos = 4,
  /// <summary>
  /// ترازو
  /// </summary>
  PosScale = 5
}
